import type { AppIcon } from "@/components/appIcons";

interface FilterSelectTriggerIconProps {
  iconUrl?: string;
  optionIcon?: AppIcon;
  fallbackIcon: AppIcon;
  showFallback: boolean;
}

export function FilterSelectTriggerIcon({
  iconUrl,
  optionIcon,
  fallbackIcon,
  showFallback,
}: FilterSelectTriggerIconProps) {
  if (iconUrl) {
    return <img src={iconUrl} alt="" className="w-4 h-auto rounded-sm shrink-0" />;
  }

  if (optionIcon) {
    const OptionIcon = optionIcon;
    return <OptionIcon className="text-[18px] text-muted-foreground shrink-0" />;
  }

  if (!showFallback) return null;

  const FallbackIcon = fallbackIcon;
  return <FallbackIcon className="text-[18px] text-muted-foreground shrink-0" />;
}
